import React from 'react';
import DesktopBookingViewControls from '../Desktop/BookingViewControls';
import {
  BookingFilterState,
  BookingSortDirection,
  BookingSortField,
  BookingViewMode,
} from '../../data/types';

type BookingViewControlsProps = {
  viewMode: BookingViewMode;
  onViewModeChange: (mode: BookingViewMode) => void;
  sortField: BookingSortField;
  onSortFieldChange: (field: BookingSortField) => void;
  sortDirection: BookingSortDirection;
  onSortDirectionChange: (direction: BookingSortDirection) => void;
  filters: BookingFilterState;
  onFiltersChange: (filters: BookingFilterState) => void;
  showFilters: boolean;
  onToggleFilters: () => void;
  activeFilterCount: number;
  onResetFilters: () => void;
  resultCount: number;
};

const BookingViewControls: React.FC<BookingViewControlsProps> = (props) => (
  <div className="-mx-2">
    <DesktopBookingViewControls {...props} />
  </div>
);

export default BookingViewControls;
